/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_OrdersInputs */

const en_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Orders`)
};

const es_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis pedidos`)
};

const fr_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes commandes`)
};

const de_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meine Bestellungen`)
};

const ja_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注文履歴`)
};

const zh_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的订单`)
};

const ar_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طلباتي`)
};

const id_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanan Saya`)
};

const it_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I Miei Ordini`)
};

const ru_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мои заказы`)
};

const pt_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meus Pedidos`)
};

const ko_my_orders = /** @type {(inputs: My_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나의 주문`)
};

/**
* | output |
* | --- |
* | "My Orders" |
*
* @param {My_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const my_orders = /** @type {((inputs?: My_OrdersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_OrdersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_my_orders(inputs)
	if (locale === "es") return es_my_orders(inputs)
	if (locale === "fr") return fr_my_orders(inputs)
	if (locale === "de") return de_my_orders(inputs)
	if (locale === "ja") return ja_my_orders(inputs)
	if (locale === "zh") return zh_my_orders(inputs)
	if (locale === "ar") return ar_my_orders(inputs)
	if (locale === "id") return id_my_orders(inputs)
	if (locale === "it") return it_my_orders(inputs)
	if (locale === "ru") return ru_my_orders(inputs)
	if (locale === "pt") return pt_my_orders(inputs)
	return ko_my_orders(inputs)
});